import type { RecoverableConfiguration, TruckConfiguration } from '#app/store/slices/configurationSlice'
import { hasUnsavedChanges } from '#features/ManCode/hasUnsavedChanges'

export const isPending = (configuration: TruckConfiguration | RecoverableConfiguration) =>
  configuration.type === 'recoverable-configuration'
    ? true
    : configuration.creation.loadingStep !== 'done' ||
      (configuration.step.requested as string) !== configuration.step.system ||
      configuration.lastManCodeUpdate?.currentlySaving ||
      configuration.history?.some((x) => x.status === 'pending' || x.status === 'queued')

export const isTruckConfiguration = (x: TruckConfiguration | RecoverableConfiguration | undefined): x is TruckConfiguration =>
  x !== undefined && x.type === 'truck-configuration'

export const isErrored = (configuration: TruckConfiguration | RecoverableConfiguration) =>
  configuration.type === 'recoverable-configuration' ? false : !!(configuration.creation.error || configuration.step.error)

export const configurationStatus = (configuration: TruckConfiguration | RecoverableConfiguration) => {
  if (isTruckConfiguration(configuration) && hasUnsavedChanges(configuration)) {
    return 'unsaved'
  }
  if (isPending(configuration)) {
    return 'saving'
  }
  return 'saved'
}

export const configurationLeadingType = (
  configuration: TruckConfiguration | RecoverableConfiguration,
  leadingConfiguration?: TruckConfiguration['id'],
) => {
  if (configuration.apiConfiguration.mode === 'read-only') {
    return 'read-only'
  }
  if (leadingConfiguration === configuration.id) {
    return 'leading'
  }
  return 'alternative'
}
